import Vue from 'vue'
import { Pagination, Button, Dialog } from 'element-ui'

Vue.use(Pagination)
Vue.use(Button)
Vue.use(Dialog)
